import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutations'
import { accounts} from '@/api/api.js';
Vue.use(Vuex)
export default new Vuex.Store({
  state: state,
  actions: {
    getAccountInfo (ctx) {
      const loginInfo = JSON.parse(localStorage.getItem('LOGIN_INFO'));
      const params = {
        id: loginInfo.id
      }
      accounts(params).then(res=>{
        if (res.code === 200) {
          ctx.commit('setAccountInfo',res.data);
        }else{
          Notify({ type: 'danger', message: res.errors[0] });
        }
      })
    }
  },
  mutations: mutations,
  //作用：借助state得到一些新的数据,避免数据冗余
  getters: {
    doubleCity (state) {
      return state.city + ' ' + state.city
    },
    isPaypalConfirmed(state) {
      return state.paypalConfirmed
    }
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js